module.exports = __webpack_public_path__ + "image-79033fec3857.png";